import { Column, Heading, Table, TableCell, TableRow } from "@amzn/meridian";
import React from "react";
import { Accuracy } from "../types";
import { formatPercent } from "src/utils/numberUtil";
import { useAppSelector } from "src/store/store";
import { Field } from "src/store/modelManagementSlice";

interface AccuracyTableProps {
  accuracy: Accuracy;
}
const AccuracyTable = ({ accuracy }: AccuracyTableProps) => {
  const { selectedModel } = useAppSelector((state) => state.modelSlice);

  const accuracyEntries =
    Object.entries(accuracy).length > 0
      ? Object.entries(accuracy)
      : Object.values(selectedModel.fields).map((field: Field) => [field.name, -1]);

  return (
    <Column spacingInset={"400 200"} spacing={"400"} width={"50%"}>
      <Heading level={3}>Field Level Accuracy</Heading>
      <Table headerRows={1} layout="fixed">
        <TableRow>
          <TableCell>Field</TableCell>
          <TableCell>Accuracy</TableCell>
        </TableRow>
        {accuracyEntries.map(([field, value]) => (
          <TableRow>
            <TableCell>{field}</TableCell>
            <TableCell>{formatPercent(value)}</TableCell>
          </TableRow>
        ))}
      </Table>
    </Column>
  );
};

export default AccuracyTable;
